import { render, staticRenderFns } from "./Shop.vue?vue&type=template&id=58a71dde&scoped=true&lang=pug&"
import script from "./Shop.vue?vue&type=script&lang=js&"
export * from "./Shop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a71dde",
  null
  
)

export default component.exports